import TrailScene from "./components/TrailScene";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LumoraWordmark from "./components/LumoraWordmark";

export default function Home() {
  return (
    <div className="relative h-screen w-full overflow-hidden bg-black text-white font-sans">
      {/* WebGL background */}
      <TrailScene />

      {/* Subtle vignette so text reads cleanly over the trails */}
      <div className="pointer-events-none absolute inset-0 z-20 bg-gradient-to-b from-black/40 via-transparent to-black/60"></div>

      <Navbar />
      <Hero />

      {/* LUMORA wordmark — isolated top-most layer */}
      <LumoraWordmark />
    </div>
  );
}